// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","icon":"Card_icon__uNzFc","selected":"Card_selected__cnSAc"};